import styled from '@emotion/styled';
import { theme } from '@/layout/GlobalStyles';
import { StaticImage } from 'gatsby-plugin-image';
import { BioPanel } from './Bio-Panel';

const staff = [
    {
        name: 'Brooklyn',
        bio: 'Brooklyn is Tallahassee born and raised! She received her A.S. in dental hygiene at Tallahassee Community College. She is currently pursuing her bachelor’s in dental hygiene at St. Petersburg College. Brooklyn is very passionate about dental hygiene and takes pride in getting to know each and every one of her patients. Helping her patients achieve optimal oral health puts a big smile on her face! In her spare time, Brooklyn enjoys being outdoors, enjoying the sunshine, and spending time with her family.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/brooklyn.jpg"
                alt="Brooklyn"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Tekealla',
        bio: 'Tekealla is a hardworking mother of seven beautiful children. She received her certification from the Dental Institute of Florida. She has been as a dental assistant for twelve years and always has a smile on her face. She has experience with specialties including endodontics and periodontics. In her free time, she enjoys writing poetry, riding her bike, and dancing.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/tekealla.jpg"
                alt="tekealla"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Kelly',
        bio: 'Kelly is one of our dental assistants, and she joined our team in May 2017, but she has been a dental assistant for 18 years. She received her certificates for dental assisting from the University of Florida, and she always does her best to care for her patients. Although she just recently joined our team, Kelly already loves the people she works with. Kelly has a wonderful family, consisting of her husband and two children. She enjoys riding horses, playing with her dogs, and spending time with her family.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/kelly.jpg"
                alt="tekealla"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Katie',
        bio: 'Katie is a certified dental assistant in expanded functions. She graduated from TCC’s dental assisting program in 2014, and she has received the Academic Achievement Award. Katie enjoys helping to make sure that our patients are taken care of when they visit our practice. She also loves the wonderful team environment that is found at First Care Dental Assoc. Katie is married and the mother to three wonderful children, two boys and one girl. When she is not at work, she enjoys being outdoors and spending time with her family. Katie also enjoys riding horses, boating, and fishing.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/katie.jpg"
                alt="tekealla"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Jennifer',
        bio: 'Jennifer is our treatment coordinator at First Care Dental Assoc. Jennifer makes sure that our patients are scheduled for their treatments in a timely manner and builds relationships with each of our clients. She loves everyone at the office. They made her feel welcome right from the start, and they show that same level of care for the patients. Jennifer is married and has two wonderful daughters. When she is not at the office, you can find her at the beach, shopping, spending time with her family or just hanging out with friends.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/jennifer.jpg"
                alt="tekealla"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Heather',
        bio: 'Heather is our hygiene coordinator, and she loves when our patients walk out with positive experiences from First Care Dental Assoc. She ensures patients are confirmed for upcoming appointments, while providing outstanding customer service and making sure everyone leaves the front desk with a smile. She checks in all patients at the front windows and coordinates with all our hygienists. Heather has two boys that bring much joy to her life. She enjoys shopping, hanging out with family and watching football.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/heather.jpg"
                alt="tekealla"
                placeholder="none"
                quality={100}
            />
        ),
    },
    {
        name: 'Jazzmin',
        bio: 'Jazzmin is our hygienist and front office assistant here at First Care Dental Assoc and began her time with us in 2019. She received her associate degree in general education in 2016 from North Florida College. She then attended Tallahassee Community College and graduated with an associate degree in dental hygiene in 2019, where she also made the honors and Dean’s list. She is a licensed dental hygienist with a certification in administering local anesthesia.Jazzmin enjoys the friendly environment of the practice and loves interacting with patients. When not doing hygiene, she helps assist the front office with answering phone calls and scheduling patients. She enjoys going to parks, traveling, filming YouTube videos, and spending time with her fiancé and two dogs.',
        image: () => (
            <StaticImage
                className="image"
                src="../images/4-meet-our-staff/jazzmin.jpg"
                alt="tekealla"
                placeholder="none"
                quality={100}
            />
        ),
    },
];

const StaffPanelsStyled = styled.footer`
    @media ${theme.device.tablet} {
    }
`;

export const StaffPanels: React.FC = () => {
    return (
        <StaffPanelsStyled className="container">
            {staff.map(member => {
                return <BioPanel key={member.name} {...member} />;
            })}
        </StaffPanelsStyled>
    );
};
